import React from 'react';
import ReactDOM from 'react-dom';

import './DialogManager.less';

import Platform from '../../../platform';

const domNode = document.getElementById('dialog-manager');

export const DialogManager = ({children}) => {
	return ReactDOM.createPortal(
		<div className={"dialog-manager " + Platform.getClasses().join(' ')}>
			{children}
		</div>,
		domNode
	)
}
